import { render, staticRenderFns } from "./AIAHeaderSearch.vue?vue&type=template&id=0ff092f2&scoped=true&"
import script from "./AIAHeaderSearch.vue?vue&type=script&lang=js&"
export * from "./AIAHeaderSearch.vue?vue&type=script&lang=js&"
import style0 from "./AIAHeaderSearch.vue?vue&type=style&index=0&id=0ff092f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff092f2",
  null
  
)

export default component.exports